<template>
  <div id="app">
    <!-- 先居中 后缩放 -->
    <div
      class="gis-container"
      :style="{
        transform:
          'translateX(-50%) translateY(-50%) translateZ(0) scale(' +
          scaleMap +
          ')',
      }"
    >
      <!-- <div class="gis-container"> -->
      <AVW></AVW>
    </div>
    <div
      class="screen"
      :style="{
        transform:
          'translateX(-50%) translateY(-50%) translateZ(0) scale(' +
          scale +
          ')',
      }"
    >
      <!-- <div class="screen"> -->

      <div class="header">
        <div class="header_text">
          <div class="logo">
            <img src="./assets/img/layout/szbg.png" alt />
          </div>
          <span>智慧机房数字孪生运维系统</span>
        </div>
        <HeaderRight @interaction="interaction" />
      </div>
      <div class="main">
        <router-view></router-view>
      </div>
    </div>
    <div
      id="layer-container"
      class="layer-container"
      :style="{
        transform:
          'translateX(-50%) translateY(-50%) translateZ(0) scale(' +
          scale +
          ')',
      }"
    >
      <!-- <div class="layer-container"> -->
      <!-- 实时告警 -->
      <div class="layout_right">
        <!-- <XiaoFangYanGan /> -->
      </div>
      <!-- 数据分析页面组件 -->
      <component :is="Dataanalysis"></component>
      <!-- 左侧组件 -->
      <component :is="leftType"></component>
      <!-- 右侧组件 -->
      <component @runInHole="rightTypeClick" :is="rightType"></component>
      <components
        :is="currentPopup"
        class="popup"
        @beginMetting="currentPopup = ''"
      />
      <EmergencyMeeting
        :style="{
          position: 'absolute',
          top: '663px',
          right: '170px',
          'z-index': 199,
        }"
      />
      <ObjectDetail
        v-show="isShowObjectDetail"
        :style="{
          position: 'absolute',
          top: '230px',
          right: '0px',
          zIndex: 99,
        }"
        @triggerEvent="triggerEvent"
        :currentPopup="currentPopup"
      />
      <!-- 漫游提示内容 -->
      <div class="tip_txt" v-show="tipTxt && functionStatus == '演示汇报'">
        <span>{{ tipTxt }}</span>
      </div>
      <!-- 底部 -->
      <div class="con_bottom">
        <div class="bot_left">
          基于图观™数字孪生应用开发引擎构建 www.digihail.com/tuguan.html
        </div>
        <div class="con_center">
          <LayerBottom
            :router="topicSecondRouter"
            :legends="topicLegends"
            @spaceBack="spaceBack"
            @legendClick="legendClick"
            @TabSwitching="navTab"
          />
        </div>
        <div class="bot_right">版权所有 北京数字冰雹信息技术有限公司</div>
      </div>
      <div class="loading" v-show="showLoading">
        <img src="./img/loading.gif" alt />
        <!-- <span class="loader-43"></span> -->
      </div>
      <RLSY
        v-if="
          LegendTextInfo.highlight &&
          ['空间使用', '功耗使用', '承重使用'].includes(LegendTextInfo.showText)
        "
      />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import layerConfig from './utils/configs/layerConfig.js'
import layerMap from './utils/configs/layerMap.js'
import UEapi from './utils/UEapi/UEapi'
import cameraList from './utils/configs/cameraList'
import legends from './utils/configs/legends'
import AVW from './views/AVW.vue'
import GisButton from '@/components/common/GisButton'
import HeaderRight from './components/common/HeaderRight'
import LayerBottom from './components/common/LayerBottom'
import NavSecond from '@/components/common/NavSecond'
import ObjectDetail from '@/components/common/ObjectDetail'
import CreatingVideoConference from '@/components/common/CreatingVideoConference'
import BusinessSystem from '@/components/common/BusinessSystem'
import MessageNotification from '@/components/common/MessageNotification'
import EmergencyMeeting from '@/components/common/EmergencyMeeting'
import MapEvent from './utils/control/MapEvent'
import YanShiHuiBao from '@/components/YanShiHuiBao/YanShiHuiBao'
import RLSY from '@/components/Popup/RL_SY'
import ObjectManager from '@/utils/control/ObjectManager'
import {
  WangLuoTaiShi,
  ZiYuanTaiShi,
  SheBeiTaiShi,
  DuiXiangGuanLi,
  ShiShiGaoJingleft,
  ShuJuZhongXingSheng,
  ShuJuZhongXingYuanQu,
  JianZhu,
  LouCeng,
  FangJian,
  JiGuiZaixian,
  JiGuiLixian,
  JiQi,
  GaoJiSouSuo,
  DuanKou,
  FuWuQiBiaoZhun,
  FuWuQiXuNiJi,
  XuNiJi,
  LuYouQi,
  JiaoHuanJi,
  OP1,
  SheXiangTouGuDing,
  SheXiangTouYunTai,
  SheXiangTouRenLianShiBie,
  MenJinSheBei,
  KeRanQiTiTanCeQi,
  XiaoFangYanGan,
  AnBaoRenYuan,
  XunJianRenYuan,
  SheBeiGaoJing,
  HuoZaiGaoJing,
  ShuiBiaoSheBei,
  DianBiaoSheBei,
  KongTiao,
  HuanJingJianCeSheBei,
} from '@/components/components'
import { setTimeout } from 'timers'
export default {
  name: 'App',
  components: {
    YanShiHuiBao,
    AVW,
    GisButton,
    HeaderRight,
    LayerBottom,
    NavSecond,
    WangLuoTaiShi,
    ZiYuanTaiShi,
    SheBeiTaiShi,
    DuiXiangGuanLi,
    ShiShiGaoJingleft,
    ShuJuZhongXingSheng,
    ShuJuZhongXingYuanQu,
    JianZhu,
    LouCeng,
    FangJian,
    JiGuiZaixian,
    JiGuiLixian,
    JiQi,
    GaoJiSouSuo,
    DuanKou,
    FuWuQiBiaoZhun,
    FuWuQiXuNiJi,
    XuNiJi,
    LuYouQi,
    JiaoHuanJi,
    OP1,
    SheXiangTouGuDing,
    SheXiangTouYunTai,
    SheXiangTouRenLianShiBie,
    MenJinSheBei,
    KeRanQiTiTanCeQi,
    XiaoFangYanGan,
    AnBaoRenYuan,
    XunJianRenYuan,
    SheBeiGaoJing,
    HuoZaiGaoJing,
    ShuiBiaoSheBei,
    DianBiaoSheBei,
    KongTiao,
    HuanJingJianCeSheBei,
    CreatingVideoConference,
    BusinessSystem,
    MessageNotification,
    EmergencyMeeting,
    ObjectDetail,
    RLSY,
  },
  data() {
    return {
      legends: null,
      topicLegends: [], // 当前主题的图例数据，发送给图例组件
      hideLegneds: [],
      topicSecondRouter: [], // 当前主题的二级路由
      scale: 1,
      scaleMap: 1,
      cameraList: cameraList, // 相机列表
      Dataanalysis: 'WangLuoTaiShi', // 数据分析动态切换
      leftType: '', // 左侧组件
      rightType: '', //右侧组件
      currentPopup: '',
      isShowObjectDetail: false,
    }
  },
  methods: {
    triggerEvent(info) {
      switch (info.name) {
        case '创建会议':
          this.currentPopup = 'CreatingVideoConference'
          break
        case '工单派发':
          this.currentPopup = 'MessageNotification'
          break
        case '跳转业务系统':
          this.currentPopup = 'BusinessSystem'
          break
        default:
          this.currentPopup = ''
          break
      }
    },
    // 右侧图表功能按钮
    rightTypeClick(name) {
      if (
        ![
          '设备正面',
          '设备反面',
          '显示虚拟机',
          '隐藏虚拟机',
          '全部显示',
          '全部隐藏',
          'Server-b22 F03 BANKA 02',
          'Server-b22 F03 BANKA 04',
        ].includes(name)
      ) {
        this.$store.commit('setRightComponents', '')
      }
      switch (name) {
        case '下钻至北京市':
          this.$store.commit('setHighLight', '北京')
          // this.$store.commit('setHighLight', '园区')
          break
        case '下钻至数据中心':
          this.$store.commit('setHighLight', '园区')
          break
        case '下钻至F3':
          this.$store.commit('setHighLight', '楼层')
          break
        case '下钻至机房01':
          this.$store.commit('setHighLight', '机柜组机房')
          break
        case '下钻至机房02':
          this.$store.commit('setHighLight', 'UPS设备机房')
          break
        case '下钻至机房03':
          this.$store.commit('setHighLight', '电池组机房')
          break
        case '下钻至机柜':
          this.modelId && this.$store.commit('setHighLight', this.modelId)
          break
        case '下钻至设备01':
          this.$store.commit('setHighLight', '设备')
          window.layerConfig.focusJiGui('C03-004-04_SM_设备机柜')
          this.$store.commit('setRightComponents', 'JiQi')
          UEapi.Camera.setCamera(cameraList['C03-004-04_SM_配线架'])
          window.layerConfig.modelOnlyHighlight('C03-004-04_SM_配线架')
          break
        case '下钻至设备02':
          this.$store.commit('setHighLight', '设备')
          window.layerConfig.focusJiGui('C03-004-04_SM_设备机柜')
          this.$store.commit('setRightComponents', 'FuWuQiXuNiJi')
          UEapi.Camera.setCamera(cameraList['C03-004-04_SM_数据服务器_虚拟机'])
          window.layerConfig.modelOnlyHighlight(
            'C03-004-04_SM_数据服务器_虚拟机'
          )
          break
        case '下钻至设备03':
          this.$store.commit('setHighLight', '设备')
          window.layerConfig.focusJiGui('C03-004-04_SM_设备机柜')
          this.$store.commit('setRightComponents', 'JiQi')
          UEapi.Camera.setCamera(cameraList['C03-004-04_SM_网络存储服务器'])
          window.layerConfig.modelOnlyHighlight('C03-004-04_SM_网络存储服务器')
          break
        case '下钻至设备04':
          this.$store.commit('setHighLight', '设备')
          window.layerConfig.focusJiGui('C03-004-04_SM_设备机柜')
          this.$store.commit('setRightComponents', 'JiQi')
          UEapi.Camera.setCamera(cameraList['C03-004-04_SM_GPU服务器'])
          window.layerConfig.modelOnlyHighlight('C03-004-04_SM_GPU服务器')
          break
        case '设备正面':
          UEapi.Camera.setCamera(cameraList[this.modelId])
          break
        case '设备反面':
          UEapi.Camera.setCamera(cameraList[`${this.modelId}设备反面`])
          break
      }
    },
    // 图例勾选
    legendClick(ele) {
      window.layerConfig.legendClick(ele)
    },
    // 场景后退
    spaceBack() {
      // this.rightType = ''
      this.$store.commit('setRightComponents', '')
      this.$store.commit('setLegendTextInfo', '')
      switch (this.spaceLevel) {
        case '设备':
          this.$store.commit('setHighLight', 'C03-004-04_SM_设备机柜')
          window.layerConfig.modelOnlyHighlight()
          break
        case '机柜':
        case '机柜组':
          this.$store.commit('setHighLight', '机柜组机房')
          window.layerConfig.recoverDefaultState()
          break
        case '房间':
        case '机柜组机房':
        case 'UPS设备机房':
        case '电池组机房':
          this.$store.commit('setHighLight', '楼层')
          window.layerConfig.recoverDefaultState()
          break
        case '楼层':
          this.$store.commit('setIsOpenDoor', { 1002: false, 1003: false })
          this.$store.commit('setHighLight', '园区')

          break
        case '园区':
          this.$store.commit('setHighLight', '北京')
          break
        case '北京':
          this.$store.commit('setHighLight', '默认服务')
          break
      }
    },
    // 页面右上角功能
    interaction(params) {
      this.$store.commit('setFunctionStatus', params)
      switch (params) {
        case '演示汇报':
          window.layerConfig.hideAllLayer()
          this.leftType = 'YanShiHuiBao'
          break
        case '对象管理':
          window.layerConfig.hideSceneLayer()
          this.leftType = 'DuiXiangGuanLi'
          break
        case '实时告警':
          window.layerConfig.hideAllLayer()
          window.layerConfig.ShowAlertLayer(params)
          this.leftType = 'ShiShiGaoJingleft'
          break
        case '返回地球':
          UEapi.OverlayTip.removeModelTipClass(this.prevModelLayer)
          this.$store.commit('setHighLight', '默认服务')
          this.leftType = ''
          break
        case '高级搜索':
          window.layerConfig.hideAllLayer()
          this.leftType = 'GaoJiSouSuo'
          break
        case '数据分析':
          switch (this.spaceLevel) {
            case '园区':
            case '楼层':
            case '机柜组机房':
            case 'UPS设备机房':
            case '电池组机房':
              this.Dataanalysis = 'SheBeiTaiShi'
              // this.$store.commit('setObjectInfo', 'SheBeiTaiShi')
              break
            default:
              this.Dataanalysis = 'WangLuoTaiShi'
              // this.$store.commit('setObjectInfo', 'WangLuoTaiShi')
              break
          }
          break
        default:
          this.appStart()
          this.leftType = ''
          this.rightType = ''
          this.$store.commit('setRightComponents', '')
      }
    },
    setScreen() {
      let visibleWidth = window.innerWidth
      let visibleHeight = window.innerHeight
      var widthPercentage = (1.0 * visibleWidth) / 3840
      var heightPercentage = (1.0 * visibleHeight) / 2160
      this.scale = Math.min(widthPercentage, heightPercentage)
      var widthPercentageMap = (1.0 * visibleWidth) / 1920
      var heightPercentageMap = (1.0 * visibleHeight) / 1080
      this.scaleMap = Math.min(widthPercentageMap, heightPercentageMap)
    },
    // 图层初始化逻辑，专题，关卡，heigHeight改变，都会触发此方法
    appStart() {
      // 获取当前专题/highLight中的配置
      let {
        sceneName,
        cameraName,
        legends,
        legendConfig,

        spaceLevel,
      } = window.layerConfig.cardName[this.highLight]
      if (!this.appInstance) {
        return
      }
      // 不同场景
      if (this.sceneName != sceneName && sceneName) {
        // 切换场景，等到场景切换成功再操作图层
        this.$store.commit('setLoading', true)
        window.layerConfig.clearTrailLayer()
        window.layerConfig.resetSceneLayers()
        UEapi.Common.switchService(sceneName)
        // 清除所有轨迹图
      } else {
        // 相同场景
        if (spaceLevel == '楼层') {
          UEapi.Common.switchState({ name: 'IDC机房_内部设施' })
          const Box = ObjectManager.Box.map((item) => item.id)
          const lines = [...ObjectManager.linkList, ...ObjectManager.linkList_2]
          setTimeout(() => {
            UEapi.Model.setModelVisibility({
              ids: Box,
              visible: false,
            })
            UEapi.Model.setModelVisibility({
              ids: lines,
              visible: false,
            })
          }, 100)
          // UEapi.Model.setModelVisibility({
          //   ids: ['SM_IDC机房楼', 'SM_IDC建筑标示_建筑'],
          //   visible: false,
          // })
        } else if (spaceLevel == '园区') {
          UEapi.Common.switchState({ name: '默认状态' })
          // UEapi.Model.setModelVisibility({
          //   ids: ['SM_IDC机房楼', 'SM_IDC建筑标示_建筑'],
          //   visible: true,
          // })
        } else if (
          [
            'C03-004-04_SM_设备机柜',
            'A01-004-04_SM_机柜组',
            'F06-004-07_SM_设备机柜',
          ].includes(this.highLight)
        ) {
          setTimeout(() => {
            window.layerConfig.focusJiGui(this.highLight)
          }, 100)
        }
        // 当前专题图例配置
        this.setLegends(legends, legendConfig)
        spaceLevel && this.$store.commit('setSpaceLevel', spaceLevel)
        // 设置相机
        cameraName && this.$store.commit('setCameraInfo', cameraName)
        // 根据图例，得到需要操作的图层
        let layers = this.legendsToLayers(legends)
        // 添加图层
        console.log(2222, layers)
        if (
          this.functionStatus != '对象管理' &&
          this.functionStatus != '实时告警'
        ) {
          window.layerConfig.addCardLayers(layers)
        }
      }
    },
    // 根据配置，从所有图例中组合出图例列表
    setLegends(legends, legendConfig) {
      // 读取图例
      let allLegends =
        window.layerConfig.legends[legendConfig || this.sceneName]
      let resList = []
      let newHideLegeds = []
      let showLegends = [] // 图例可控
      let hideLegneds = [] // 图例不可控
      // 得到图例控制的图层和非图例控制的图层
      for (const group in allLegends) {
        let tempObj = {}
        const groups = allLegends[group]
        tempObj.type = group
        tempObj.img = layerConfig.groupImgs[group]
        tempObj.highlight = false
        tempObj.children = []
        for (const legend in groups) {
          const item = groups[legend]
          let highLight = legends.includes(item.txt)
          tempObj.children.push({
            txt: item.txt,
            img: item.img,
            showText: item.showText || item.txt,
            highlight: highLight,
            layers: item.layers,
          })
          if (highLight) {
            tempObj.highlight = true
            showLegends.push(...item.layers)
          }
          // else {
          //   newHideLegeds.push(...item.layers)
          //   hideLegneds.push(...item.layers)
          // }
        }
        resList.push(tempObj)
      }
      // resList.forEach((item) => {
      //   item.children = item.children.filter((ele) => {
      //     return !newHideLegeds.includes(ele.layers[0])
      //   })
      // })
      this.topicLegends = resList
      // this.hideLegneds = hideLegneds
    },
    // 根据当前图例，查找对应要显示的图层
    legendsToLayers(legends) {
      let layers = []
      legends.forEach((layer) => {
        // 图例可以控制的图层
        this.topicLegends.forEach((group) => {
          group.children.forEach((ele) => {
            if (ele.txt == layer) {
              layers.push(...ele.layers)
            }
          })
        })
        // 不显示图例的图层
        // this.hideLegneds.forEach((legend) => {
        //   if (legend.txt == layer) {
        //     layers.push(...legend.layers)
        //   }
        // })
      })
      return layers
    },
    // 场景切换成功
    sceneChangedCallback(res) {
      let that = this
      console.log('onSceneSwitch', res)
      this.$store.commit('setSceneName', res.name)
      console.log('onSceneSwitch', res)
      // 当前专题图例配置
      let {
        cameraName,
        sceneWeather,
        sceneTime,
        legends,
        legendConfig,
        spaceLevel,
      } = window.layerConfig.cardName[this.highLight]
      spaceLevel && this.$store.commit('setSpaceLevel', spaceLevel)
      if (spaceLevel == '楼层') {
        UEapi.Common.switchState({ name: 'IDC机房_内部设施' })
        UEapi.Model.setModelVisibility({
          ids: ['SM_IDC建筑标示_建筑'],
          visible: false,
        })
      } else if (spaceLevel == '园区') {
        UEapi.Common.switchState({ name: '默认状态' })
        UEapi.Model.setModelVisibility({
          ids: ['SM_IDC建筑标示_建筑'],
          visible: true,
        })
      }
      this.setLegends(legends, legendConfig)
      // 限制地图
      // this.restrictCamera(res.name)
      cameraName && this.$store.commit('setCameraInfo', cameraName)
      sceneWeather && this.$store.commit('setSceneWeather', sceneWeather)
      sceneTime && this.$store.commit('setSceneTime', sceneTime)
      // 添加每个场景专属图层，如地标建筑，城市名称等等
      window.layerConfig.addDefaultLayers()
      let layers = this.legendsToLayers(legends)
      if (this.functionStatus != '对象管理') {
        window.layerConfig.addCardLayers(layers)
      } else {
        if (this.sceneName != '园区') {
          window.layerConfig.addCardLayers(layers)
        }
      }
    },
    loadService() {
      window.streamingConfig.mapList.forEach((item, index) => {
        if (index >= 1) {
          UEapi.Common.loadService(item)
        }
      })
    },
    navTab(p) {
      switch (p) {
        case '网络态势':
          this.Dataanalysis = 'WangLuoTaiShi'
          break
        case '资源态势':
          this.Dataanalysis = 'ZiYuanTaiShi'
          break
        case '设备态势':
          this.Dataanalysis = 'SheBeiTaiShi'
          break
      }
    },
  },
  async created() {
    // 加载全部数据
    this.$axios.get('./data/all/点位汇总.json').then((res) => {
      window.allData = res.data
    })
  },
  mounted() {
    window.layerConfig = layerConfig
    window.layerMap = layerMap
    window.UEapi = UEapi
    let that = this
    //立即执行显示分辨率设置方法
    this.setScreen()
    window.addEventListener('resize', this.setScreen.bind(this))
    document.oncontextmenu = function (ev) {
      ev.preventDefault()
    }
    window.appInstance.uniCall('addEventListener', {
      eventName: 'onServiceLoad',
      callback: (res) => {
        console.log('onServiceLoad', res)
      },
    })
    window.addEventListener('onLandmarkLayerClick', (res) => {
      MapEvent.pointClick(res)
    })
    window.addEventListener('on3DMarkerClick', (res) => {})
    window.addEventListener('onLandmarkLayerHover', (res) => {
      console.log(
        res.detail.idLayer.slice(3, 10),
        res.detail.idObj.slice(-2),
        'onLandmarkLayerHover'
      )
      MapEvent.LandmarkLayerHover(res)
    })
    window.addEventListener('onLandmarkLayerUnhover', (res) => {
      MapEvent.LandmarkLayerUnhover(res)
    })
    window.addEventListener('onModelClick', (res) => {
      MapEvent.modelClick(res)
    })
    window.addEventListener('onModelHover', (res) => {
      MapEvent.modelHover(res)
    })
    window.addEventListener('onModelUnhover', (res) => {
      MapEvent.modelUnhover(res)
    })
    window.addEventListener('onBuildingHover', (res) => {})
    window.addEventListener('onBuildingUnhover', (res) => {})
    window.addEventListener('onBuildingClick', (res) => {})
    window.addEventListener('onFloorClick', (res) => {})
    window.addEventListener('onFloorHover', (res) => {})
    window.addEventListener('onFloorUnhover', (res) => {})
    window.addEventListener('onEventLayerClick', (res) => {
      MapEvent.eventLayerClick(res)
    })
    // 注册初始化事件
    appInstance.uniCall('addEventListener', {
      eventName: 'onServiceInit',
      callback: (res) => {
        appInstance.uniCall('getScenesInfo', {}, (res) => {
          console.log('当前场景', res)
          // 设置当前场景相关属性
          this.$store.commit('setSceneName', '默认服务')
          window.layerConfig.addDefaultLayers()
          this.$store.commit('setAppInstance', true)
          this.$store.commit('setLoading', false)
          // 设置默认highLight为二级专题
          this.$store.commit('setHighLight', '默认服务')
          // 可以根据初始名字，设置相机视野限制
          // this.restrictCamera(sceneName)
        })
        this.loadService()
        UEapi.Events.initEventCallback()
      },
    })
    appInstance.uniCall('addEventListener', {
      eventName: 'onServiceSwitch',
      callback: (res) => {
        window.appInstance.uniCall(
          'setSceneEffect',
          {
            lightPower: 1,
            isLayerTopMost: true,
            divTipMovingDelay: 200,
            focusDuration: 1,
            gis3dtileShadow: true,
            labelColorStyle: 'none',
          },
          (res) => {
            console.log('setSceneEffect', res)
          }
        )
        if (res.name == '园区') {
          UEapi.Events.pickModel()
          UEapi.Events.hoverModel()
          UEapi.Events.pickBuilding()
          UEapi.Events.hoverBuilding()
        }
        this.$store.commit('setRightComponents', '')
        this.sceneChangedCallback(res)
        this.$store.commit('setLoading', false)
        // UEapi.Events.initEventCallback()
      },
    }),
      appInstance.uniCall('addEventListener', {
        eventName: 'onStateSwitch',
        callback: (res) => {
          console.log(res, '切换状态成功')
          if ((res.name = 'IDC机房_内部设施')) {
            const Box = ObjectManager.Box.map((item) => item.id)
            const lines = [
              ...ObjectManager.linkList,
              ...ObjectManager.linkList_2,
            ]
            UEapi.Model.setModelVisibility({
              ids: Box,
              visible: false,
            })
            UEapi.Model.setModelVisibility({
              ids: lines,
              visible: false,
            })
          }
        },
      })
  },
  computed: {
    ...mapState([
      'tipTxt',
      'showLoading',
      'topic',
      'subTopic',
      'highLight',
      'appInstance',
      'sceneName',
      'cameraInfo',
      'cameraRotate',
      'spaceLevel',
      'functionStatus',
      'rightComponents',
      'objectInfo',
      'modelId',
      'LegendTextInfo',
      'prevModelLayer',
    ]),
  },
  watch: {
    highLight: {
      handler(val) {
        if (this.appInstance) {
          this.appStart(val)
        }
      },
      deep: true,
    },
    spaceLevel: {
      handler(val) {
        this.isShowObjectDetail = false
      },
      deep: true,
    },
    $route: {
      handler: function (to, from) {
        // 设置topic名称
        this.$store.commit('setTopic', to.matched[0].meta.cname || '')
        if (to.matched[1]) {
          this.$store.commit('setSubTopic', to.matched[1].meta.cname)
        } else {
          this.$store.commit('setSubTopic', '')
        }
        // 根据专题调用场景状态
        if (!this.appInstance) {
          return
        }
      },
      deep: true,
    },
    cameraInfo: {
      handler(val) {
        UEapi.Camera.setCamera(cameraList[val])
      },
      deep: true,
    },
    cameraRotate: {
      handler(val) {
        window.appInstance.uniCall('rotateCamera', {
          enabled: val,
          duration: 240,
          direction: 'clockwise',
          interruptable: true,
        })
      },
      deep: true,
    },
    rightComponents: {
      handler(val) {
        this.isShowObjectDetail = false
        this.rightType = val
      },
      deep: true,
    },
    objectInfo: {
      handler(val) {
        this.rightType = ''
        this.isShowObjectDetail = val ? true : false
      },
      deep: true,
    },
    functionStatus: {
      handler(newVal, oldVal) {
        if (oldVal == '高级搜索') {
          window.layerConfig.recoverDefaultState()
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="less">
@appWidht: 3840px;
@appHeight: 2160px;
#app {
  user-select: none;
  cursor: pointer;
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  overflow: hidden;
  pointer-events: all;
  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: @appWidht;
    height: @appHeight;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.3);
    pointer-events: all;
  }
  .gis-container {
    background-color: #000;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 1920px;
    height: 1080px;
    overflow: hidden;
  }
  .screen {
    position: absolute;
    background: url(./assets/img/layout/mask.png) no-repeat center center;
    left: 50%;
    top: 50%;
    z-index: 2;
    width: @appWidht;
    height: @appHeight;
    pointer-events: none;
    overflow: hidden;
    .header {
      .temp {
        position: absolute;
        top: 10px;
        left: 800px;
        display: flex;
        div {
          padding: 0 5px;
          color: #fff;
          font-size: 20px;
        }
      }
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100px;
      z-index: 10;
      pointer-events: all;
      box-sizing: border-box;
      .header_text {
        .logo {
          height: 58px;
          padding-top: 2px;
        }
        margin-left: 40px;
        width: 730px;
        height: 100px;
        line-height: 100px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: '微软雅黑';
        font-size: 54px;
        color: #ffffff;
        font-weight: 700;
      }
    }
    .main {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: @appHeight;
      pointer-events: none;
      z-index: 5;
    }
    .gis_btn_pos {
      position: absolute;
      left: 920px;
      bottom: 50px;
      z-index: 10;
    }
    .legend_pos {
      position: absolute;
      bottom: 40px;
      right: 920px;
      z-index: 100;
    }
  }
  .layer-container {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 2;
    width: @appWidht;
    height: @appHeight;
    pointer-events: none;
    overflow: hidden;
    .tip_txt {
      position: absolute;
      width: 864px;
      height: 85px;
      background-image: url(./assets/img/YanShiHuiBao/tip_bg.png);
      text-align: center;
      position: relative;
      top: 200px;
      left: 50%;
      transform: translateX(-50%);
      overflow: hidden;
      span {
        padding: 0 40px;
        background-image: linear-gradient(to bottom, #fff, #21f3f3);
        -webkit-background-clip: text;
        white-space: nowrap;
        color: transparent;
        font-size: 34px;
        font-family: '碳纤维正粗黑简体';
        line-height: 85px;
      }
    }
    .con_bottom {
      position: absolute;
      bottom: 0px;
      width: 100%;
      height: 100px;
      display: flex;
      font-family: '微软雅黑';
      font-size: 24px;
      color: #cccccc;
      justify-content: space-between;
      line-height: 100px;
      .bot_left {
        text-indent: 30px;
        opacity: 0.6;
      }
      .bot_right {
        opacity: 0.6;
        padding-right: 30px;
      }
      .con_center {
        width: 100%;
        height: 100px;
        position: absolute;
        left: 0px;
      }
    }
  }

  .popup {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(2);
    z-index: 99;
  }
}
</style>
